var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.5H8V4.5H4V8.5ZM10 20.5H14V16.5H10V20.5ZM8 20.5H4V16.5H8V20.5ZM4 14.5H8V10.5H4V14.5ZM14 14.5H10V10.5H14V14.5ZM16 4.5V8.5H20V4.5H16ZM14 8.5H10V4.5H14V8.5ZM16 14.5H20V10.5H16V14.5ZM20 20.5H16V16.5H20V20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.0ba65eeb8f0e0bfab0ccf67856e19051.svg";
export { ForwardRef as ReactComponent };